module.exports = __webpack_public_path__ + "img/approve-schedule.53f1c079.svg";